import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Alert,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { toast } from "react-hot-toast";
import PublicAccessService from "../../services/KangarooServices/PublicAcessService";





const PublicPasswordChange = () => {
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const [show, setShow] = useState({
    password: false,
    confirmPassword: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleShow = (field) => {
    setShow((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.password) {
      return toast.error("Password is required");
    }

    if (form.password !== form.confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      setLoading(true);

      await PublicAccessService.update({
        password: form.password,
      });

      toast.success("Password updated successfully");

      setForm({
        password: "",
        confirmPassword: "",
      });
    } catch (error) {
      console.log(error);
      toast.error("Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid page-content align-items-center d-flex justify-content-center" >
      <Card className="shadow-sm border-0 col-6">
        <CardHeader className="bg-light border-bottom">
          <h5 className="mb-0">Public Page Password Settings</h5>
        </CardHeader>

        <CardBody>
          <Alert color="info">
            This password protects your public page. Users must enter this
            password before accessing the content.
          </Alert>

          <Form onSubmit={handleSubmit}>
            {/* Password */}
            <FormGroup className="mb-3">
              <Label>New Password</Label>
              <InputGroup>
                <Input
                  type={show.password ? "text" : "password"}
                  name="password"
                  placeholder="Enter new password"
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <InputGroupText
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleShow("password")}
                >
                  <i
                    className={`bx ${
                      show.password ? "bx-show" : "bx-hide"
                    }`}
                  ></i>
                </InputGroupText>
              </InputGroup>
            </FormGroup>

            {/* Confirm Password */}
            <FormGroup className="mb-3">
              <Label>Confirm Password</Label>
              <InputGroup>
                <Input
                  type={show.confirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <InputGroupText
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleShow("confirmPassword")}
                >
                  <i
                    className={`bx ${
                      show.confirmPassword ? "bx-show" : "bx-hide"
                    }`}
                  ></i>
                </InputGroupText>
              </InputGroup>
            </FormGroup>

            {/* Submit */}
            <div className="d-flex justify-content-end">
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save Changes"}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default PublicPasswordChange;